import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { Issue } from '../types';
import IssueCard from './IssueCard';

const namespace = 'Issues';

interface IssueListProps {
  issues: Issue[];
  onOpen: (issue: Issue) => void;
}

export const IssueList: React.FC<IssueListProps> = ({ issues, onOpen }) => {
  if (issues.length === 0) {
    return (
      <div className="IssueList__empty">
        <span className="IssueList__empty-icon">
          <Icon name="bullHorn" />
        </span>
        <Text as="div" size="body-medium" color="Neutral600">
          {t('emptyState', namespace)}
        </Text>
      </div>
    );
  }

  return (
    <div className="IssueList">
      {issues.map((issue) => (
        <IssueCard key={issue.id} issue={issue} onOpen={onOpen} />
      ))}
    </div>
  );
};

export default IssueList;
